    <template>
  <div v-if="raw && raw.data">
    <section v-if="!blnIsDetail && !blnIsProductDetail"></section>
    <!-- Uebersicht -->
    <section v-else-if="blnIsDetail && !blnIsProductDetail">
      <!-- <section
				v-if="raw.data.attributes.productcategories"
				is="app-content-element-slider"
				type="Slider"
				:objectdata="raw.data.attributes.productcategories"
			></section>-->

      <section
        v-if="raw.data.attributes.slider"
        is="app-content-element-slider"
        type="Slider"
        :autoplay="true"
        :objectdata="raw.data.attributes.slider"
      ></section>
      <div class="screen-wrapper">
        <div class="site-back-btn">
          <a onclick="history.back()" class="btn-go-back">Zurück</a>
          <span>
            <span></span>
            <span></span>
          </span>
        </div>
      </div>
      <section class="content-wrapper" v-if="raw.data.attributes.categorytext">
        <h3 class="text-center">{{ raw.data.attributes.categoryheadline }}</h3>
        <p v-html="raw.data.attributes.categorytext"></p>
      </section>

      <section class="content-wrapper">
        <div class="mod_product-teaser" v-if="raw.data && raw.data.attributes">
          <div
            class="product-teaser"
            v-for="(item, index) in raw.data.attributes.products"
            :key="'p' + index"
          >
            <div class="flag-new" v-if="item.flagnew">
              <svg
                version="1.1"
                id="flag-svg"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 78 78"
                style="enable-background: new 0 0 78 78"
                xml:space="preserve"
              >
                <path
                  class="flag-bg"
                  d="M0,76.8V26.5c3.2-6.3,2.8-7.3,36.2-12.5C69.1,8.9,76,6,78,0c0,0,0,50.2,0,50.2c-0.9,2.8-5.3,6.2-33.7,11c-17.5,2.9-24.4,4.1-30.6,6C3.8,70.3,3.7,71,0,76.8z"
                />
                <g>
                  <path
                    class="flag-text"
                    d="M20.1,48.3l-2.7-16.1l2.3-0.4l6.5,7.3c1.5,1.7,2.7,3.2,3.8,4.7l0,0c-0.6-2.1-0.9-4.1-1.4-6.6l-1.1-6.7l2-0.3l2.7,16.1L30,46.6l-6.5-7.3c-1.4-1.6-2.8-3.3-3.9-4.9l-0.1,0c0.5,2,0.8,3.9,1.3,6.6L22,48L20.1,48.3z"
                  />
                  <path
                    class="flag-text"
                    d="M42.8,36.7l-6.3,1.1l1,5.8l7-1.2l0.3,1.7l-9,1.5l-2.7-16.1l8.7-1.5l0.3,1.7L35.4,31l0.9,5.1l6.3-1.1L42.8,36.7z"
                  />
                  <path
                    class="flag-text"
                    d="M46.9,27.2l1.6,9.5c0.6,3.6,2.5,4.9,4.6,4.5c2.4-0.4,3.6-2.2,3-5.8L54.6,26l2.1-0.4l1.6,9.4c0.8,4.9-1.4,7.4-4.9,8c-3.3,0.6-6.1-0.9-6.9-5.9l-1.6-9.5L46.9,27.2z"
                  />
                  <path
                    class="flag-text"
                    d="M62.3,36.4L60.1,25l2.3-0.4l1.6,11.5L62.3,36.4z M62.3,39.9c-0.1-0.9,0.3-1.6,1.2-1.7c0.9-0.1,1.5,0.4,1.7,1.2c0.1,0.8-0.3,1.6-1.2,1.7C63.1,41.3,62.4,40.8,62.3,39.9z"
                  />
                </g>
              </svg>
            </div>

            <a
              @click="gotoPage($route.path + '/' + item.alias)"
              :title="item.title"
            >
              <img :src="item.productimage3" :alt="item.title" />
              <div class="product-teaser--info">
                <h5>{{ item.title }}</h5>
                <h6>{{ item.claim }}</h6>
              </div>
            </a>
          </div>
        </div>
      </section>
    </section>

    <section v-else-if="blnIsDetail && blnIsProductDetail">
      <carousel-3d
        :style="
          raw.data.attributes.productcategory &&
          raw.data.attributes.productcategory.categorydetailsliderimage
            ? 'background-image:url(\'' +
              raw.data.attributes.productcategory.categorydetailsliderimage +
              '\')'
            : ''
        "
        v-if="raw.data.attributes.productsInCateogry"
        :display="raw.data.attributes.productsInCateogry.length"
        :dir="'ltr'"
        :space="calculatewidth"
        :perspective="0"
        :animationSpeed="900"
        :width="100"
        :height="370"
        :startIndex="raw.data.attributes.coverslideindex"
      >
        <slide
          v-for="(item, index) in raw.data.attributes.productsInCateogry"
          :index="index"
          :key="index"
          style="text-align: center; background: transparent; border: none"
          :data-product-bg="item.teaserbackgroundimage"
        >
          <a
            @click="gotoPage(getBaseUrlFolder() + '/' + item.alias)"
            :title="item.title"
          >
            <img
              :src="item.productimage1"
              :alt="item.title + ' ' + item.claim"
            />
            <div class="product-teaser--info">
              <h5>{{ item.sliderheadline }}</h5>
            </div>
          </a>
        </slide>
      </carousel-3d>
      <div class="screen-wrapper">
        <div class="site-back-btn">
          <a onclick="history.back()" class="btn-go-back">Zurück</a>
          <span>
            <span></span>
            <span></span>
          </span>
        </div>
      </div>
      <nav class="mod_subnavigation">
        <ul>
          <li
            v-for="(item, index) in raw.data.attributes.productcategories"
            v-if="
              item &&
              item.alias &&
              item.alias != parent &&
              item.alias != current
            "
            :key="'catelink' + index"
          >
            <a @click="gotoPage('/produkte/' + item.alias)">{{ item.title }}</a>
          </li>
        </ul>
      </nav>

      <section class="content-wrapper">
        <!-- Detail -->
        <h2 class="text-center">{{ raw.data.attributes.title }}</h2>
        <div class="detail-wrapper">
          <div class="detail-product">
            <div class="detail-info">
              <div class="detail-image">
                <img
                  :src="raw.data.attributes.productimage1"
                  :alt="raw.data.attributes.title"
                />
              </div>
              <div class="detail-buttons">
                <a
                  v-if="raw.data.attributes.check_info1"
                  data-info="infolink-1"
                  class="btn btn-circle"
                  title
                  :style="
                    'background-color:#' +
                    raw.data.attributes.info1_buttoncolor +
                    ';'
                  "
                  @click="openDetail('1'), showActiveDetailBtn('1')"
                  :data-rgb="
                    convertHexToRgb(raw.data.attributes.info1_buttoncolor)
                  "
                >
                  <span>{{ raw.data.attributes.info1_button }}</span>
                </a>
                <a
                  v-if="raw.data.attributes.check_info2"
                  data-info="infolink-2"
                  class="btn btn-circle"
                  title
                  :style="
                    'background-color:#' +
                    raw.data.attributes.info2_buttoncolor +
                    ';'
                  "
                  @click="openDetail('2'), showActiveDetailBtn('2')"
                  :data-rgb="
                    convertHexToRgb(raw.data.attributes.info2_buttoncolor)
                  "
                >
                  <span>{{ raw.data.attributes.info2_button }}</span>
                </a>
                <a
                  v-if="raw.data.attributes.check_info3"
                  data-info="infolink-3"
                  class="btn btn-circle"
                  title
                  :style="
                    'background-color:#' +
                    raw.data.attributes.info3_buttoncolor +
                    ';'
                  "
                  @click="openDetail('3'), showActiveDetailBtn('3')"
                  :data-rgb="
                    convertHexToRgb(raw.data.attributes.info3_buttoncolor)
                  "
                >
                  <span>{{ raw.data.attributes.info3_button }}</span>
                </a>
                <a
                  v-if="raw.data.attributes.check_info6"
                  data-info="infolink-6"
                  class="btn btn-circle"
                  title
                  :style="
                    'background-color:#' +
                    raw.data.attributes.info6_buttoncolor +
                    ';'
                  "
                  @click="openDetail('6'), showActiveDetailBtn('6')"
                  :data-rgb="
                    convertHexToRgb(raw.data.attributes.info6_buttoncolor)
                  "
                >
                  <span>{{ raw.data.attributes.info6_button }}</span>
                </a>

                <a
                  v-if="raw.data.attributes.naehrwerte"
                  data-info="infolink-4"
                  class="btn btn-circle"
                  @click="openDetail('4', 'high'), showActiveDetailBtn('4')"
                  :style="
                    raw.data.attributes.usecustombubblecolors &&
                    raw.data.attributes.bubble4color
                      ? 'background-color:#' +
                        raw.data.attributes.bubble4color +
                        ';'
                      : ''
                  "
                >
                  <span>Nährwert&shy;tabelle</span>
                </a>

                <a
                  v-if="raw.data.attributes.naehrwerte"
                  data-info="infolink-5"
                  class="btn btn-circle"
                  @click="openDetail('5', 'high'), showActiveDetailBtn('5')"
                  :style="
                    raw.data.attributes.usecustombubblecolors &&
                    raw.data.attributes.bubble5color
                      ? 'background-color:#' +
                        raw.data.attributes.bubble5color +
                        ';'
                      : ''
                  "
                >
                  <span>Zutaten</span>
                </a>

                <!-- <a
									v-if="raw.data.attributes.naehrwerte"
									data-info="infolink-6"
									class="btn btn-circle"
									@click="openDetail('6','high')"
									:style="( (raw.data.attributes.usecustombubblecolors && raw.data.attributes.bubble6color) ? 'background-color:#' + raw.data.attributes.bubble6color+ ';' : '')"
								>
									<span>Zusatz&shy;stoffe</span>
								</a>-->
              </div>
            </div>

            <div class="detail-infobox">
              <div class="infoboxlayer-1">
                <img
                  :src="raw.data.attributes.info1_backgroundimage"
                  :alt="raw.data.attributes.info1_title"
                />
                <div
                  class="infobox-text animated delay-025s"
                  :style="
                    raw.data.attributes.productcategory != undefined &&
                    raw.data.attributes.productcategory
                      .categorybubblefontcolor != ''
                      ? 'color:#' +
                        raw.data.attributes.productcategory
                          .categorybubblefontcolor +
                        ';'
                      : ''
                  "
                >
                  <h4>{{ raw.data.attributes.info1_title }}</h4>
                  <p
                    v-bind:inner-html.prop="
                      raw.data.attributes.info1_description
                        | nl2br
                        | replaceNbsp
                        | replaceAmp
                        | replaceParenthesisLeft
                        | replaceParenthesisRight
                    "
                  />
                  <!-- <p>{{raw.data.attributes.info1_description}}</p> -->
                  <a class="btn-close" @click="closeDetail()">
                    <svg
                      version="1.1"
                      id="Ebene_1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 29 28.3"
                      style="enable-background: new 0 0 29 28.3"
                      xml:space="preserve"
                    >
                      <path
                        class="st2"
                        :style="
                          raw.data.attributes.productcategory != undefined &&
                          raw.data.attributes.productcategory
                            .categorybubblefontcolor != ''
                            ? 'fill:#' +
                              raw.data.attributes.productcategory
                                .categorybubblefontcolor +
                              ' !important;'
                            : ''
                        "
                        d="M26,0H3C1.3,0,0,1.3,0,3v22c0,1.7,1.3,3,3,3h23c1.7,0,3-1.3,3-3V3C29,1.3,27.7,0,26,0z M25.2,22.8l-1.4,1.4l-9-9l-9,9l-1.4-1.4l9-9l-9-9l1.4-1.4l9,9l9-9l1.4,1.4l-9,9L25.2,22.8z"
                      />
                    </svg>
                  </a>
                </div>
              </div>
              <div class="infoboxlayer-2">
                <img
                  :src="raw.data.attributes.info2_backgroundimage"
                  :alt="raw.data.attributes.info2_title"
                />
                <div
                  class="infobox-text animated delay-025s"
                  :style="
                    raw.data.attributes.productcategory != undefined &&
                    raw.data.attributes.productcategory
                      .categorybubblefontcolor != ''
                      ? 'color:#' +
                        raw.data.attributes.productcategory
                          .categorybubblefontcolor +
                        ';'
                      : ''
                  "
                >
                  <h4>{{ raw.data.attributes.info2_title }}</h4>
                  <!-- <p>{{raw.data.attributes.info2_description}}</p> -->
                  <p
                    v-bind:inner-html.prop="
                      raw.data.attributes.info2_description
                        | nl2br
                        | replaceNbsp
                        | replaceAmp
                        | replaceParenthesisLeft
                        | replaceParenthesisRight
                    "
                  />
                  <a class="btn-close" @click="closeDetail()">
                    <svg
                      version="1.1"
                      id="Ebene_1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 29 28.3"
                      style="enable-background: new 0 0 29 28.3"
                      xml:space="preserve"
                    >
                      <path
                        class="st2"
                        :style="
                          raw.data.attributes.productcategory != undefined &&
                          raw.data.attributes.productcategory
                            .categorybubblefontcolor != ''
                            ? 'fill:#' +
                              raw.data.attributes.productcategory
                                .categorybubblefontcolor +
                              ' !important;'
                            : ''
                        "
                        d="M26,0H3C1.3,0,0,1.3,0,3v22c0,1.7,1.3,3,3,3h23c1.7,0,3-1.3,3-3V3C29,1.3,27.7,0,26,0z M25.2,22.8l-1.4,1.4l-9-9l-9,9l-1.4-1.4l9-9l-9-9l1.4-1.4l9,9l9-9l1.4,1.4l-9,9L25.2,22.8z"
                      />
                    </svg>
                  </a>
                </div>
              </div>
              <div class="infoboxlayer-3">
                <img
                  :src="raw.data.attributes.info3_backgroundimage"
                  :alt="raw.data.attributes.info3_title"
                />
                <div
                  class="infobox-text animated delay-025s"
                  :style="
                    raw.data.attributes.productcategory != undefined &&
                    raw.data.attributes.productcategory
                      .categorybubblefontcolor != ''
                      ? 'color:#' +
                        raw.data.attributes.productcategory
                          .categorybubblefontcolor +
                        ';'
                      : ''
                  "
                >
                  <h4>{{ raw.data.attributes.info3_title }}</h4>
                  <p
                    v-bind:inner-html.prop="
                      raw.data.attributes.info3_description
                        | nl2br
                        | replaceNbsp
                        | replaceAmp
                        | replaceParenthesisLeft
                        | replaceParenthesisRight
                    "
                  />
                  <a class="btn-close" @click="closeDetail()">
                    <svg
                      version="1.1"
                      id="Ebene_1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 29 28.3"
                      style="enable-background: new 0 0 29 28.3"
                      xml:space="preserve"
                    >
                      <path
                        class="st2"
                        :style="
                          raw.data.attributes.productcategory != undefined &&
                          raw.data.attributes.productcategory
                            .categorybubblefontcolor != ''
                            ? 'fill:#' +
                              raw.data.attributes.productcategory
                                .categorybubblefontcolor +
                              ' !important;'
                            : ''
                        "
                        d="M26,0H3C1.3,0,0,1.3,0,3v22c0,1.7,1.3,3,3,3h23c1.7,0,3-1.3,3-3V3C29,1.3,27.7,0,26,0z M25.2,22.8l-1.4,1.4l-9-9l-9,9l-1.4-1.4l9-9l-9-9l1.4-1.4l9,9l9-9l1.4,1.4l-9,9L25.2,22.8z"
                      />
                    </svg>
                  </a>
                </div>
              </div>
              <div v-if="raw.data.attributes.naehrwerte" class="infoboxlayer-4">
                <div class="infobox-text animated delay-025s">
                  <h4>100 ml enthalten durchschnittlich:</h4>
                  <div class="rs-table">
                    <!-- Nährwerte -->
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.energiecal"
                    >
                      <div>Energie:</div>
                      <div>
                        {{ raw.data.attributes.naehrwerte.energiekj }} kJ ({{
                          raw.data.attributes.naehrwerte.energiecal
                        }}
                        kcal)
                      </div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.fett"
                    >
                      <div>Fett:</div>
                      <div>{{ raw.data.attributes.naehrwerte.fett }}</div>
                    </div>
                    <div
                      class="rs-table-row nobordertop"
                      v-show="raw.data.attributes.naehrwerte.fettgs"
                    >
                      <div>- davon gesättige Fettsäuren:</div>
                      <div>{{ raw.data.attributes.naehrwerte.fettgs }}</div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.einfachgs"
                    >
                      <div>1-fach ungesättigte FS:</div>
                      <div>{{ raw.data.attributes.naehrwerte.einfachgs }}</div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.mehrfachgs"
                    >
                      <div>mehrfach unges. FS:</div>
                      <div>{{ raw.data.attributes.naehrwerte.mehrfachgs }}</div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.kohlenhydrate"
                    >
                      <div>Kohlenhydrate:</div>
                      <div>
                        {{ raw.data.attributes.naehrwerte.kohlenhydrate }}
                      </div>
                    </div>
                    <div
                      class="rs-table-row nobordertop"
                      v-show="
                        raw.data.attributes.naehrwerte.fettzucker ||
                        raw.data.attributes.naehrwerte.fettzucker != '0 g'
                      "
                    >
                      <div>
                        - davon Zucker
                        <sup>*</sup>:
                      </div>
                      <div>{{ raw.data.attributes.naehrwerte.fettzucker }}</div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.ballaststf"
                    >
                      <div>Ballaststoffe:</div>
                      <div>{{ raw.data.attributes.naehrwerte.ballaststf }}<span v-show="raw.data.attributes.naehrwerte.claimbalast">*</span></div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.eiweiss"
                    >
                      <div>Eiweiß:</div>
                      <div>{{ raw.data.attributes.naehrwerte.eiweiss }}<span v-show="raw.data.attributes.naehrwerte.claimeiweiss">**</span></div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.natrium"
                    >
                      <div>Natrium:</div>
                      <div>{{ raw.data.attributes.naehrwerte.natrium }}</div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.salz"
                    >
                      <div>Salz:</div>
                      <div>{{ raw.data.attributes.naehrwerte.salz }}</div>
                    </div>

                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.alkohole"
                    >
                      <div>mehrwertige Alkohole:</div>
                      <div>{{ raw.data.attributes.naehrwerte.alkohole }}</div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.starke"
                    >
                      <div>Stärke:</div>
                      <div>{{ raw.data.attributes.naehrwerte.starke }}</div>
                    </div>
                    <!-- Vitamine -->
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.vitaminagewicht"
                    >
                      <div>
                        Vitamin A:
                        <br />(aus natürlichem Beta-Carotin)
                      </div>
                      <div>
                        {{ raw.data.attributes.naehrwerte.vitaminagewicht }},
                        {{ raw.data.attributes.naehrwerte.vitaminaprozent }} NRV
                        <sup>***</sup>
                        <br />
                        {{
                          raw.data.attributes.naehrwerte
                            .vitaminanatuerlichgewicht
                        }}
                      </div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.vitaminb1gewicht"
                    >
                      <div>Thiamin:</div>
                      <div>
                        {{ raw.data.attributes.naehrwerte.vitaminb1gewicht }},
                        {{
                          raw.data.attributes.naehrwerte.vitaminb1prozent
                        }}
                        NRV
                        <sup>***</sup>
                      </div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.vitaminb12gewicht"
                    >
                      <div>Vitamin B12:</div>
                      <div>
                        {{ raw.data.attributes.naehrwerte.vitaminb12gewicht }},
                        {{
                          raw.data.attributes.naehrwerte.vitaminb12prozent
                        }}
                        NRV
                        <sup>***</sup>
                      </div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.vitaminb2gewicht"
                    >
                      <div>Riboflavin:</div>
                      <div>
                        {{ raw.data.attributes.naehrwerte.vitaminb2gewicht }},
                        {{
                          raw.data.attributes.naehrwerte.vitaminb2prozent
                        }}
                        NRV
                        <sup>***</sup>
                      </div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.vitaminb3gewicht"
                    >
                      <div>Niacin:</div>
                      <div>
                        {{ raw.data.attributes.naehrwerte.vitaminb3gewicht }},
                        {{
                          raw.data.attributes.naehrwerte.vitaminb3prozent
                        }}
                        NRV
                        <sup>***</sup>
                      </div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.vitaminb5gewicht"
                    >
                      <div>Pantothensäure:</div>
                      <div>
                        {{ raw.data.attributes.naehrwerte.vitaminb5gewicht }},
                        {{
                          raw.data.attributes.naehrwerte.vitaminb5prozent
                        }}
                        NRV
                        <sup>***</sup>
                      </div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.vitaminb6gewicht"
                    >
                      <div>Vitamin B6:</div>
                      <div>
                        {{ raw.data.attributes.naehrwerte.vitaminb6gewicht }},
                        {{
                          raw.data.attributes.naehrwerte.vitaminb6prozent
                        }}
                        NRV
                        <sup>***</sup>
                      </div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.vitaminb7gewicht"
                    >
                      <div>Biotin:</div>
                      <div>
                        {{ raw.data.attributes.naehrwerte.vitaminb7gewicht }},
                        {{
                          raw.data.attributes.naehrwerte.vitaminb7prozent
                        }}
                        NRV
                        <sup>***</sup>
                      </div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.vitaminb9gewicht"
                    >
                      <div>Folsäure:</div>
                      <div>
                        {{ raw.data.attributes.naehrwerte.vitaminb9gewicht }},
                        {{
                          raw.data.attributes.naehrwerte.vitaminb9prozent
                        }}
                        NRV
                        <sup>***</sup>
                      </div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.vitamincgewicht"
                    >
                      <div>Vitamin C:</div>
                      <div>
                        {{ raw.data.attributes.naehrwerte.vitamincgewicht }},
                        {{ raw.data.attributes.naehrwerte.vitamincprozent }} NRV
                        <sup>***</sup>
                      </div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.vitamindgewicht"
                    >
                      <div>Vitamin D:</div>
                      <div>
                        {{ raw.data.attributes.naehrwerte.vitamindgewicht }},
                        {{ raw.data.attributes.naehrwerte.vitamindprozent }} NRV
                        <sup>***</sup>
                      </div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.vitaminegewicht"
                    >
                      <div>Vitamin E:</div>
                      <div>
                        {{ raw.data.attributes.naehrwerte.vitaminegewicht }},
                        {{ raw.data.attributes.naehrwerte.vitamineprozent }} NRV
                        <sup>***</sup>
                      </div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.vitaminkgewicht"
                    >
                      <div>Vitamin K (Phyllochinon):</div>
                      <div>
                        {{ raw.data.attributes.naehrwerte.vitaminkgewicht }},
                        {{ raw.data.attributes.naehrwerte.vitaminkprozent }} NRV
                        <sup>***</sup>
                      </div>
                    </div>
                    <!-- Mineralstoffe -->
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.chloridgewicht"
                    >
                      <div>Chlorid:</div>
                      <div>
                        {{ raw.data.attributes.naehrwerte.chloridgewicht }},
                        {{ raw.data.attributes.naehrwerte.chloridprozent }} NRV
                        <sup>***</sup>
                      </div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.chromgewicht"
                    >
                      <div>Chrom:</div>
                      <div>
                        {{ raw.data.attributes.naehrwerte.chromgewicht }},
                        {{ raw.data.attributes.naehrwerte.chromprozent }} NRV
                        <sup>***</sup>
                      </div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.eisengewicht"
                    >
                      <div>Eisen:</div>
                      <div>
                        {{ raw.data.attributes.naehrwerte.eisengewicht }},
                        {{ raw.data.attributes.naehrwerte.eisenprozent }} NRV
                        <sup>***</sup>
                      </div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.fluoridgewicht"
                    >
                      <div>Fluorid:</div>
                      <div>
                        {{ raw.data.attributes.naehrwerte.fluoridgewicht }},
                        {{ raw.data.attributes.naehrwerte.fluoridprozent }} NRV
                        <sup>***</sup>
                      </div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.kaliumgewicht"
                    >
                      <div>Kalium:</div>
                      <div>
                        {{ raw.data.attributes.naehrwerte.kaliumgewicht }},
                        {{ raw.data.attributes.naehrwerte.kaliumprozent }} NRV
                        <sup>***</sup>
                      </div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.kalziumgewicht"
                    >
                      <div>Kalzium:</div>
                      <div>
                        {{ raw.data.attributes.naehrwerte.kalziumgewicht }},
                        {{ raw.data.attributes.naehrwerte.kalziumprozent }} NRV
                        <sup>***</sup>
                      </div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.kupfergewicht"
                    >
                      <div>Kupfer:</div>
                      <div>
                        {{ raw.data.attributes.naehrwerte.kupfergewicht }},
                        {{ raw.data.attributes.naehrwerte.kupferprozent }} NRV
                        <sup>***</sup>
                      </div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.magnesiumgewicht"
                    >
                      <div>Magnesium:</div>
                      <div>
                        {{ raw.data.attributes.naehrwerte.magnesiumgewicht }},
                        {{
                          raw.data.attributes.naehrwerte.magnesiumprozent
                        }}
                        NRV
                        <sup>***</sup>
                      </div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.mangangewicht"
                    >
                      <div>Mangan:</div>
                      <div>
                        {{ raw.data.attributes.naehrwerte.mangangewicht }},
                        {{ raw.data.attributes.naehrwerte.manganprozent }} NRV
                        <sup>***</sup>
                      </div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.molybdaengewicht"
                    >
                      <div>Molybdän:</div>
                      <div>
                        {{ raw.data.attributes.naehrwerte.molybdaengewicht }},
                        {{
                          raw.data.attributes.naehrwerte.molybdaenprozent
                        }}
                        NRV
                        <sup>***</sup>
                      </div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.phosphorgewicht"
                    >
                      <div>Phosphor:</div>
                      <div>
                        {{ raw.data.attributes.naehrwerte.phosphorgewicht }},
                        {{ raw.data.attributes.naehrwerte.phosphorprozent }} NRV
                        <sup>***</sup>
                      </div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.selengewicht"
                    >
                      <div>Selen:</div>
                      <div>
                        {{ raw.data.attributes.naehrwerte.selengewicht }},
                        {{ raw.data.attributes.naehrwerte.selenprozent }} NRV
                        <sup>***</sup>
                      </div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.zinkgewicht"
                    >
                      <div>Zink:</div>
                      <div>
                        {{ raw.data.attributes.naehrwerte.zinkgewicht }},
                        {{ raw.data.attributes.naehrwerte.zinkprozent }} NRV
                        <sup>***</sup>
                      </div>
                    </div>
                    <!-- Verbraucherinfo -->
                    <div
                      class="rs-table-row"
                      v-show="
                        raw.data.attributes.naehrwerte.gentech &&
                        raw.data.attributes.naehrwerte.gentech != 'nein'
                      "
                    >
                      <div>gentechnologische Angaben:</div>
                      <div>{{ raw.data.attributes.naehrwerte.gentech }}</div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="
                        raw.data.attributes.naehrwerte.ernaehrung &&
                        raw.data.attributes.naehrwerte.ernaehrung != 'keine'
                      "
                    >
                      <div>Ernährungs&shy;weise:</div>
                      <div v-html="raw.data.attributes.naehrwerte.ernaehrung == 'Sellerie' ? '<strong>Sellerie</strong>' : raw.data.attributes.naehrwerte.ernaehrung"></div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="
                        raw.data.attributes.naehrwerte.allergene &&
                        raw.data.attributes.naehrwerte.allergene != 'nein'
                      "
                    >
                      <div>Enthaltene Allergene:</div>
                      <div v-html="raw.data.attributes.naehrwerte.allergene == 'Sellerie' ? '<strong>Sellerie</strong>' : raw.data.attributes.naehrwerte.allergene"></div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="
                        raw.data.attributes.naehrwerte.bio &&
                        raw.data.attributes.naehrwerte.bio != 'nein'
                      "
                    >
                      <div>BIO:</div>
                      <div>{{ raw.data.attributes.naehrwerte.bio }}</div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.fsc"
                    >
                      <div>FSC:</div>
                      <div>{{ raw.data.attributes.naehrwerte.fsc }}</div>
                    </div>
                    <!-- Zusatzstoffe -->
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.jodgewicht"
                    >
                      <div>Jod:</div>
                      <div>
                        {{ raw.data.attributes.naehrwerte.jodgewicht }},
                        {{ raw.data.attributes.naehrwerte.jodprozent }} NRV
                        <sup>***</sup>
                      </div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.polyphenole"
                    >
                      <div>Polyphenole:</div>
                      <div>
                        {{ raw.data.attributes.naehrwerte.polyphenole }}
                      </div>
                    </div>
                    <div
                      class="rs-table-row"
                      v-show="raw.data.attributes.naehrwerte.inulin"
                    >
                      <div>Inulin:</div>
                      <div>{{ raw.data.attributes.naehrwerte.inulin }}</div>
                    </div>
                  </div>
                  <p style="text-align: left; padding-left: 0">
                    <small
                      v-show="
                        raw.data.attributes.naehrwerte.fettzucker ||
                        raw.data.attributes.naehrwerte.fettzucker != '0 g'
                      "
                    >
                      {{ raw.data.attributes.naehrwerte.claimzucker }}
                      <br />
                    </small>
                    <small v-show="raw.data.attributes.naehrwerte.claimeiweiss">{{
                      raw.data.attributes.naehrwerte.claimeiweiss
                    }}<br /></small>
                    <small v-show="raw.data.attributes.naehrwerte.claimbalast">{{
                      raw.data.attributes.naehrwerte.claimbalast
                    }}<br /></small>
                    <small v-show="raw.data.attributes.naehrwerte.claimnrv">{{
                      raw.data.attributes.naehrwerte.claimnrv
                    }}</small>

                  
                  </p>

                  <a class="btn-close" @click="closeDetail()">
                    <svg
                      version="1.1"
                      id="Ebene_1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 29 28.3"
                      style="enable-background: new 0 0 29 28.3"
                      xml:space="preserve"
                    >
                      <path
                        class="st2"
                        d="M26,0H3C1.3,0,0,1.3,0,3v22c0,1.7,1.3,3,3,3h23c1.7,0,3-1.3,3-3V3C29,1.3,27.7,0,26,0z M25.2,22.8l-1.4,1.4l-9-9l-9,9l-1.4-1.4l9-9l-9-9l1.4-1.4l9,9l9-9l1.4,1.4l-9,9L25.2,22.8z"
                      />
                    </svg>
                  </a>
                </div>
              </div>
              <div v-if="raw.data.attributes.naehrwerte" class="infoboxlayer-5">
                <div class="infobox-text animated delay-025s">
                  <h4>Zutaten</h4>
                  <p v-html="raw.data.attributes.naehrwerte.zutaten"></p>
                  <a class="btn-close" @click="closeDetail()">
                    <svg
                      version="1.1"
                      id="Ebene_1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 29 28.3"
                      style="enable-background: new 0 0 29 28.3"
                      xml:space="preserve"
                    >
                      <path
                        class="st2"
                        d="M26,0H3C1.3,0,0,1.3,0,3v22c0,1.7,1.3,3,3,3h23c1.7,0,3-1.3,3-3V3C29,1.3,27.7,0,26,0z M25.2,22.8l-1.4,1.4l-9-9l-9,9l-1.4-1.4l9-9l-9-9l1.4-1.4l9,9l9-9l1.4,1.4l-9,9L25.2,22.8z"
                      />
                    </svg>
                  </a>
                </div>
              </div>
              <div v-if="raw.data.attributes.naehrwerte" class="infoboxlayer-6">
                <img
                  :src="raw.data.attributes.info6_backgroundimage"
                  :alt="raw.data.attributes.info6_title"
                />
                <div class="infobox-text animated delay-025s">
                  <h4>{{ raw.data.attributes.info6_title }}</h4>
                  <p>{{ raw.data.attributes.info6_description }}</p>

                  <a class="btn-close" @click="closeDetail()">
                    <svg
                      version="1.1"
                      id="Ebene_1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 29 28.3"
                      style="enable-background: new 0 0 29 28.3"
                      xml:space="preserve"
                    >
                      <path
                        class="st2"
                        d="M26,0H3C1.3,0,0,1.3,0,3v22c0,1.7,1.3,3,3,3h23c1.7,0,3-1.3,3-3V3C29,1.3,27.7,0,26,0z M25.2,22.8l-1.4,1.4l-9-9l-9,9l-1.4-1.4l9-9l-9-9l1.4-1.4l9,9l9-9l1.4,1.4l-9,9L25.2,22.8z"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <video
		v-if="raw.data.attributes.alias == 'vitamin-d'"
          controls
          muted
          autoplay
          style="max-width: 100%;margin-top:20px; margin-bottom:40px;"
          class="videoanne"
		  id="video"
        >
          <source
            src="https://www.amecke.de/files/videos/AMECKE-Plus-VitaminD-fuer-die-Abwehrkraefte-final.mp4"
            type="video/mp4"
          />
        </video>
        <!-- <h2 v-if="raw.data.attributes.naehrwerte" class="text-center">Zutaten</h2>
				<p v-if="raw.data.attributes.naehrwerte">{{raw.data.attributes.naehrwerte.zutaten}}</p>-->
        <h2 class="text-center">
          {{ raw.data.attributes.descriptionheadline }}
        </h2>
        <p v-html="raw.data.attributes.description"></p>
      </section>

      <section class="content-wrapper" v-if="raw.data.attributes.isoeko">
        <h3 class="text-center">{{ raw.data.attributes.oekoheadline }}</h3>

        <p v-html="raw.data.attributes.oekotext"></p>
        <p class="text-center">
          <img
            :src="raw.data.attributes.oeko_image"
            :alt="raw.data.attributes.oekoheadline"
          />
        </p>
      </section>

      <section class="content-wrapper">
        <!-- PRODUCT TEASER -->
        <h3 class="text-center">Diese Säfte könnten Dich auch interessieren</h3>
        <section class="mod_category-teaser">
          <div
            class="category-teaser"
            v-for="(item, index) in raw.data.attributes.productcategories"
            v-if="
              item &&
              item.alias &&
              item.alias != parent &&
              item.alias != current
            "
            :key="'catteaser' + index"
          >
            <a @click="gotoPage('/produkte/' + item.alias)">
              <img :src="item.categoryimage" :alt="item.title" />
              {{ item.title }}
              <div class="category-teaser--info">
                <h5 :style="'color:#' + item.categorycolor">
                  {{ item.title }}
                </h5>
              </div>
            </a>
          </div>
        </section>
      </section>
    </section>
  </div>
</template>
    <script>
import Base from "./Base.vue";
import AppContentElementSlider from "./AppContentElementSlider";
import { Carousel3d, Slide } from "vue-carousel-3d";
// import {
//   Hooper,
//   Slide,
//   Navigation as HooperNavigation,
//   Pagination as HooperPagination
// } from "hooper";
// // import "hooper/dist/hooper.css";

export default {
  components: {
    AppContentElementSlider,
    Carousel3d,
    Slide,
    // Hooper,
    // Slide,
    // HooperNavigation,
    // HooperPagination
  },
  extends: Base,
  data() {
    return {
      currentCategory: false,
      blnIsDetail: false,
      blnIsProductDetail: false,
      blnInitedJQ: false,
      objectdata: false,
      vueroutename: this.$route.params.current,
      document: document,
      apicomponentname:
        this.$route.path == "/produkte" || !this.$route.params.parent
          ? "productcategories"
          : "products",
    };
  },
  updated() {
    this.blnIsDetail = this.$route.path == "/produkte" ? false : true;

    this.blnIsProductDetail = this.$route.params.parent ? true : false;

    this.checkPlayVideo();
  },
  created() {
    // if (this.current == "startseite") {
    //   this.current = "produktestartseite";
    // }
    // if (this.parent == "startseite") {
    //   this.parent = "produktestartseite";
    // }

    this.init();
  },
  methods: {
    init() {
      this.objectdata = {};
      this.parent = this.$route.params.parent;
      this.current = this.$route.params.current;
      this.blnIsDetail = this.$route.path == "/produkte" ? false : true;
      this.blnIsProductDetail = this.$route.params.parent ? true : false;

      this.getList();

      this.getDetailButtonColor();
      setTimeout(() => {
		let elem = document.querySelector(".videoanne");
		if (this.$route.hash == '#video') {
		if (elem) {
			elem.scrollIntoView({
          block: 'start',
          behavior: 'smooth'
        })
 
        // document.addEventListener("scroll", () => {
			
          var promise = elem.play();

          if (promise !== undefined) {
            promise
              .then((_) => {
				console.log('Autoplay started!')
				elem.muted = false;
                // Autoplay started!
              })
              .catch((error) => {
                console.log('Autoplay was prevented.')
				// document.querySelector("video").play()
                // Autoplay was prevented.
                // Show a "Play" button so that user can start playback.
              });
          }
		}
	}
        //   console.log(elem.visible);
        //   if (elem && elem.readyState >= 3) {
        //     console.log(elem);
        //     if (elem.playing) {
        //       elem.muted = false;
        //     //   elem.play();
        //     }
        //     // clearInterval(b);
        //   }
          // if (videoElem) {
          // 	setTimeout(()=>{
          // 	// videoElem.removeAttribute("muted")
          // 	videoElem.muted = false
          // 	console.log(videoElem);

          // 	videoElem.volume=1;
          // },1000)
        // });
        // }
      }, 2000);
    },
    postInit() {
      if (this.raw.data.length) {
        let objParam = false;
        if (this.raw.data.attributes) {
          objParam = this.raw.data;
        } else {
          objParam = this.raw.data[0];
        }

        this.currentCategory =
          this.raw.data.length && objParam && objParam.attributes
            ? objParam.attributes.alias
            : false;

        if (this.currentCategory) {
          this.$router.push("/produkte/" + this.currentCategory);
        }
        setTimeout(() => {
          // this.$children[0].$children[0].$children[0].$hooper.restart();
        }, 100);
      }
      this.ranInit = false;
      if (!this.blnInitedJQ) {
        this.blnInitedJQ = true;

        setTimeout(() => {
          this.nextSlideHeight("init");
          // set height of current image to carousel-slider container
          let elem = document.querySelector(
            ".carousel-3d-slider > .current img"
          );
          if (elem) {
            let paddingHeight = 100;
            if (window.innerWidth > 767) {
              paddingHeight = 200;
            }
            let elemData = elem.getBoundingClientRect();
            let elemContainerHeight = parseInt(elemData.height + paddingHeight);
            let elemSliderHeight = parseInt(elemData.height);
            let carouselContainer = document.querySelector(
              ".carousel-3d-container"
            );
            let carouselSlider = document.querySelector(".carousel-3d-slider");
            carouselContainer.style.height = elemContainerHeight + "px";
            carouselSlider.style.height = elemSliderHeight + "px";
          }
        }, 500);
      }
    },
    getDetailButtonColor() {
      setTimeout(() => {
        let allDetailButtons = document.querySelectorAll(
          ".detail-product .detail-info .btn-circle"
        );
        let rgbColor = "";
        let detailBtn = "";

        [].forEach.call(allDetailButtons, (el) => {
          rgbColor = el.getAttribute("data-rgb");
          detailBtn = el.getAttribute("data-info");
          // console.log(rgbColor);
          this.generateDetailButtonKeyframe(detailBtn, rgbColor);
        });
      }, 900);
    },
    generateDetailButtonKeyframe(btnName, color) {
      let detailParentNode =
        document.querySelector(".detail-product").parentNode;
      let detailNode = document.querySelector(".detail-product");
      let styleElem = document.createElement("style");

      let btnPulseSize = "12px";
      let btnPulseTime = "2s";
      let btnPulseAlpha = ".4";

      let detailBtnCssString =
        ".detail-product .detail-info .btn-circle[data-info='" +
        btnName +
        "']:hover {" +
        "animation: pulse-" +
        btnName +
        " " +
        btnPulseTime +
        ";}" +
        "@-webkit-keyframes pulse-" +
        btnName +
        " {" +
        "0% {-webkit-box-shadow: 0 0 0 0 rgba(" +
        color +
        ", " +
        btnPulseAlpha +
        ");}" +
        "70% {-webkit-box-shadow: 0 0 0 " +
        btnPulseSize +
        " rgba(" +
        color +
        ", 0);}" +
        "100% {-webkit-box-shadow: 0 0 0 0 rgba(" +
        color +
        ", 0);}}" +
        "@keyframes pulse-" +
        btnName +
        " {" +
        "0% {-moz-box-shadow: 0 0 0 0 rgba(" +
        color +
        ", " +
        btnPulseAlpha +
        ");box-shadow: 0 0 0 0 rgba(" +
        color +
        ", 0.4);}" +
        "70% {-moz-box-shadow: 0 0 0 " +
        btnPulseSize +
        " rgba(" +
        color +
        ", 0);box-shadow: 0 0 0 " +
        btnPulseSize +
        " rgba(" +
        color +
        ", 0);}" +
        "100% {-moz-box-shadow: 0 0 0 0 rgba(" +
        color +
        ", 0);box-shadow: 0 0 0 0 rgba(" +
        color +
        ", 0);}}";

      styleElem.innerHTML = detailBtnCssString;
      setTimeout(() => {
        detailParentNode.insertBefore(styleElem, detailNode);
      }, 500);
    },
    convertHexToRgb(color) {
      let r = "";
      let g = "";
      let b = "";
      let result = "";
      if (color.length === 6) {
        r = parseInt(color.substring(0, 2), 16);
        g = parseInt(color.substring(2, 4), 16);
        b = parseInt(color.substring(4, 6), 16);
        result = r + "," + g + "," + b;
      } else {
        result = "23,93,59";
      }
      return result;
    },
    checkproduct(event) {
      let arr = this.raw.data.attributes.sliderselect.slideritems;
      let targetProduct = arr[event.currentSlide++];
      // console.log(this.ranInit);
      // console.log(event);
      // console.log(
      // 	this.$children[0].$children[0].$children[0].$hooper.currentSlide
      // );
    },
    openOverlay() {
      var elems = document.querySelectorAll(
        ".overlay,.detail-product .overlay-content.overlay-content-naehr"
      );
      [].forEach.call(elems, (el) => {
        el.classList.add("js-active");
      });
      // scroll layer to top - for mobile
      if (window.innerWidth < 768) {
        setTimeout(() => {
          let activeLayer = document.querySelector(".detail-infobox.js-active");
          let activeLayerTopPos = this.getOffset(activeLayer).top - 20;
          window.scrollTo({
            top: activeLayerTopPos,
            behavior: "smooth",
          });
        }, 500);
      }

      // elems = document.querySelectorAll('.detail-product .overlay-content');
      // [].forEach.call(elems, el => {
      //               el.classList.add("js-active");
      // });

      //       $('.detail-product .overlay-content').addClass('js-active');
    },
    openOverlayZusatz() {
      var elems = document.querySelectorAll(
        ".overlay,.detail-product .overlay-content.overlay-content-zusatz"
      );
      [].forEach.call(elems, (el) => {
        el.classList.add("js-active");
      });
      // elems = document.querySelectorAll('.detail-product .overlay-content');
      // [].forEach.call(elems, el => {
      //               el.classList.add("js-active");
      // });

      //       $('.detail-product .overlay-content').addClass('js-active');
    },
    closeOverlay() {
      var elems = document.querySelector(".overlay-content");
      var elemOverlay = document.querySelector(".overlay");
      // elems.classList.add("fadeOutDown");
      if (elems) {
        elems.classList.remove("js-active");
      }
      if (elemOverlay) {
        elemOverlay.classList.remove("js-active");
      }

      // [].forEach.call(elems, el => {
      //   el.classList.add("fadeOutDown");
      // });

      setTimeout(() => {
        if (elems) {
          elems.classList.remove("fadeOutDown");
        }
      }, 500);
    },
    closeOverlayZusatz() {
      var elems = document.querySelector(".overlay-content-zusatz");
      var elemOverlay = document.querySelector(".overlay");
      // elems.classList.add("fadeOutDown");
      if (elems) {
        elems.classList.remove("js-active");
      }
      if (elemOverlay) {
        elemOverlay.classList.remove("js-active");
      }

      // [].forEach.call(elems, el => {
      //   el.classList.add("fadeOutDown");
      // });

      setTimeout(() => {
        if (elems) {
          elems.classList.remove("fadeOutDown");
        }
      }, 500);
    },
    showActiveDetailBtn(id) {
      var currentId = id;
      var btnElems = document.querySelectorAll(".detail-buttons > .btn-circle");
      [].forEach.call(btnElems, (el) => {
        el.classList.remove("js-active");
      });
      var elemInfoBtn = document.querySelector(
        ".detail-buttons [data-info='infolink-" + currentId + "']"
      );
      elemInfoBtn.classList.add("js-active");
    },
    openDetail(id, containerType) {
      var setContainerHigh = false;
      // new class for table-content
      if (containerType == "high") {
        setContainerHigh = true;
      }

      var currentId = id;
      var elems = document.querySelectorAll(".overlay,.overlay-content");
      // var btnElems = document.querySelectorAll(
      // 	".detail-buttons > .btn-circle"
      // );
      [].forEach.call(elems, (el) => {
        el.classList.remove("js-active");
      });
      // [].forEach.call(btnElems, el => {
      // 	el.classList.remove("js-active");
      // });

      var elems = document.querySelectorAll(
        'div[class*="infoboxlayer-"].js-active'
      );

      if (elems.length < 1) {
        var elemInfoBox = document.querySelector(".detail-infobox");
        var elemProductBox = document.querySelector(".detail-product");

        elemInfoBox.classList.add("js-active");
        // console.log("first");
        if (setContainerHigh) {
          elemProductBox.classList.add("detail-product-high");
        }

        var elemInfoLayer = document.querySelector(".infoboxlayer-" + id);
        var elemInfoLayerText = document.querySelector(
          ".infoboxlayer-" + id + " .infobox-text"
        );
        // console.log(elemInfoLayer);
        elemInfoLayer.classList.add("js-active");
        elemInfoLayerText.classList.add("fadeInUp");

        // var elemInfoBtn = document.querySelector(
        // 	".detail-buttons [data-info='infolink-" + currentId + "']"
        // );
        // elemInfoBtn.classList.add("js-active");
      } else {
        // console.log(setContainerHigh);
        var activeBox = document.querySelector(
          ".infoboxlayer-" + currentId + ".js-active"
        );
        if (!activeBox) {
          this.closeDetail();
          setTimeout(() => {
            var elemInfoBox = document.querySelector(".detail-infobox");
            var elemProductBox = document.querySelector(".detail-product");

            elemInfoBox.classList.add("js-active");
            // console.log("second");
            if (setContainerHigh) {
              elemProductBox.classList.add("detail-product-high");
            }
            var elemInfoLayer = document.querySelector(
              ".infoboxlayer-" + currentId
            );
            var elemInfoLayerText = document.querySelector(
              ".infoboxlayer-" + currentId + " .infobox-text"
            );
            // console.log(elemInfoLayer);
            elemInfoLayer.classList.add("js-active");
            elemInfoLayerText.classList.add("fadeInUp");

            // var elemInfoBtn = document.querySelector(
            // 	".detail-buttons [data-info='infolink-" +
            // 		currentId +
            // 		"']"
            // );
            // elemInfoBtn.classList.add("js-active");
          }, 1800);
        }
      }
      if (window.innerWidth < 768) {
        this.openOverlay();
      }
    },
    closeDetail() {
      var elemInfoBtn = document.querySelectorAll(
        ".detail-buttons .btn.js-active"
      );
      [].forEach.call(elemInfoBtn, (el) => {
        el.classList.remove("js-active");
      });
      var elem = document.querySelector(
        ".detail-infobox.js-active > div.js-active .infobox-text"
      );
      var elemProductBox = document.querySelector(".detail-product");

      elem.classList.add("fadeOutDown");
      setTimeout(() => {
        var elem = document.querySelector(".detail-infobox");
        elem.classList.remove("js-active");
        // elemProductBox.classList.remove("detail-product-high");
        this.clearAll();
      }, 500);
      setTimeout(() => {
        elemProductBox.classList.remove("detail-product-high");
      }, 800);
    },
    clearAll() {
      setTimeout(() => {
        var elems = document.querySelectorAll(".overlay,.overlay-content");
        [].forEach.call(elems, (el) => {
          el.classList.remove("js-active");
          el.classList.remove("fadeOutDown");
          el.classList.remove("fadeInUp");
        });
        var elems = document.querySelectorAll(
          ".overlay,.overlay-content-zusatz"
        );
        [].forEach.call(elems, (el) => {
          el.classList.remove("js-active");
          el.classList.remove("fadeOutDown");
          el.classList.remove("fadeInUp");
        });
        var elems = document.querySelectorAll(".detail-infobox > div");
        [].forEach.call(elems, (el) => {
          el.classList.remove("js-active");
          el.classList.remove("fadeOutDown");
          el.classList.remove("fadeInUp");
        });
        var elems = document.querySelectorAll(".detail-infobox > div > div");
        [].forEach.call(elems, (el) => {
          el.classList.remove("js-active");
          el.classList.remove("fadeOutDown");
          el.classList.remove("fadeInUp");
        });
        // var elems = document.querySelectorAll(".detail-buttons > .btn");
        // [].forEach.call(elems, el => {
        // 	el.classList.remove("js-active");
        // });
        this.closeOverlay();
        this.closeOverlayZusatz();
      }, 1000);
    },
  },
  computed: {
    calculatewidth(value) {
      // setTimeout(function() {
      // 	console.log($(".carousel-3d-container"));
      // }, 1500);
      if (window.innerWidth > 768) {
        return (
          window.innerWidth /
            this.raw.data.attributes.productsInCateogry.length +
          10
        );
      } else {
        return 80;
      }
    },
  },
  watch: {
    $route(to, from) {
      // if (
      // 	this.raw &&
      // 	this.raw.data &&
      // 	this.raw.data.attributes &&
      // 	this.raw.data.attributes.sliderselect
      // ) {
      // 	this.raw = false;
      // }
      this.objectdata = {};
      this.raw.data.attributes.slideritems = false;
      this.apicomponentname =
        to.path == "/produkte" || !to.params.parent
          ? "productcategories"
          : "products";
      this.init();
      setTimeout(() => {
        // this.$children[1].$children[0].$children[0].$hooper.restart();
      }, 800);
    },
  },
};
</script>

    <style lang="scss">
@import "@/scss/variables.scss";
@import "@/scss/mixins.scss";
@import "@/scss/_animations.scss";

// product-detail variables
// $btn-pulse-size: 12px;
// $btn-pulse-time: 2s;
// $btn-pulse-alpha: 0.4;
$button-alpha: 0.4;
$content-alpha: 0.9;

// product-detail styles
.detail-wrapper {
  .detail-product {
    margin-bottom: 50px;
    text-align: center;
    &.detail-product-high {
      [class*="infoboxlayer-"] {
        &.js-active {
          display: block;
          height: 100%;
          width: 100%;
        }
      }
    }

    @include min-screen($screen-min-m) {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 0;
      &.detail-product-high {
        align-items: flex-start;
        .detail-infobox {
          height: 0;
          &.js-active {
            height: 800px;
            overflow: hidden;
            overflow-y: scroll;
            h4 {
              margin-top: 0 !important;
              color: $color-green;
            }
            p {
              color: $color-green;
            }
            .rs-table {
              .rs-table-row {
                > div {
                  padding: 10px 5px;
                  &:not(:first-child) {
                    text-align: right;
                  }
                  &:first-child {
                    padding-bottom: 10px;
                  }
                }
              }
            }
            .infobox-text {
              height: 100%;
              width: 100%;
              .btn-close {
                svg {
                  path {
                    fill: $color-green !important;
                  }
                }
              }
            }
          }
          [class*="infoboxlayer-"] {
            &.js-active {
              display: inline-block;
            }
          }
        }
      }
    }

    .detail-info {
      clear: both;
      display: inline-block;
      position: relative;
      width: 100%;

      @include min-screen($screen-min-m) {
        width: auto;
        // margin: 10px 84px;
        margin: 10px 84px 10px 200px;
      }

      img {
        display: inline-block;
        margin-bottom: 20px;
        max-width: 60px;

        @include min-screen($screen-min-m) {
          margin-bottom: 0;
          max-width: 130px;
        }
      }
    }

    .detail-buttons {
      display: inline-block;
      .btn {
        float: left;
        transition: opacity 0.25s ease-in-out;

        &:nth-child(2n + 1) {
          clear: left;
          margin-right: 20px;
        }
        &.js-active {
          opacity: 0.6;
        }
      }
      @include min-screen($screen-min-m) {
        .btn {
          float: none;
          margin-right: 0;
          &:nth-child(2n + 1) {
            clear: left;
            margin-right: 0;
          }
        }
      }
    }

    .detail-link {
      margin-top: 20px;

      .link {
        text-align: left;

        &:after {
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }

    .btn {
      display: block;
      margin: 0 auto 20px;
      opacity: 0.8;

      @include min-screen($screen-min-m) {
        display: inline-block;
        position: absolute;

        &:nth-of-type(1) {
          top: 50px;
          left: -105px;
          right: auto;
        }

        &:nth-of-type(2) {
          top: 118px;
          left: -200px;
          right: auto;
        }

        &:nth-of-type(3) {
          top: 176px;
          left: -105px;
          right: auto;
        }
        &:nth-of-type(4) {
          top: 238px;
          left: -200px;
          right: auto;
        }
        &:nth-of-type(5) {
          top: 298px;
          left: -105px;
          right: auto;
        }
        &:nth-of-type(6) {
          top: 360px;
          left: -200px;
          right: auto;
        }
      }
    }

    .detail-infobox {
      color: $color-grey-dark;
      overflow: hidden;
      padding: 0;
      transition: left 0.7s ease-in-out, height 0.7s ease-in-out,
        width 0.7s ease-in-out;
      height: auto;
      min-height: 200px;
      left: -150%;
      position: absolute;
      top: 10%;
      width: 100%;
      z-index: 7;

      @include min-screen($screen-min-m) {
        background: none;
        color: $color-white;
        height: 0;
        left: auto;
        min-height: auto;
        padding: 0;
        position: relative;
        top: auto;
        transition: height 0.7s ease-in-out, width 0.7s ease-in-out,
          padding 0.7s ease-in-out;
        width: 0;
        // .detail-product-high & {
        // 	height: 0;
        // 	// h4 {
        // 	// 	margin-top: 0 !important;
        // 	// }
        // }
      }

      &.js-active {
        background: $color-beige;
        background: rgba($color-beige-rgb, $content-alpha);
        // border: 1px solid $color-green;
        // border-width: 1px 0;
        left: 0;
        // top: 5%;
        width: 100%;
        // z-index: 7;

        @include min-screen($screen-min-m) {
          background: none;
          // border-width: 0;
          height: 400px;
          // left: auto;
          padding: 15px;
          width: 400px;
        }
      }
      // @include min-screen($screen-min-m) {
      // 	.detail-product-high & {
      // 		&.js-active {
      // 			height: auto;
      // 			// h4 {
      // 			// 	margin-top: 0 !important;
      // 			// }
      // 		}
      // 	}
      // }

      // @include max-screen($screen-max-m) {
      //     height: 0;
      //     position: absolute;
      //     width: 100%;
      // }

      [class*="infoboxlayer-"] {
        color: $color-white;
        display: none;

        img {
          left: 0;
          position: absolute;
          top: 0;
          z-index: -1;
        }

        @include max-screen($screen-max-m) {
          color: $color-grey-dark;
          z-index: 5;

          img {
            display: none;
          }
        }

        .infobox-text {
          display: none;
          opacity: 0;
          transition: opacity 0.25s ease-in-out;

          h4 {
            display: block;
            margin: 50px 0 16px;
            padding: 0;

            &:after {
              border: none;
              content: "";
            }
          }

          p {
            text-align: center;
            padding: 0 40px;
          }

          .btn-close {
            display: inline-block;
            height: 30px;
            position: relative;
            width: 30px;

            svg {
              height: 30px;
              width: 30px;

              path {
                fill: rgba($color-black-rgb, $button-alpha) !important;
              }
            }

            @include min-screen($screen-min-m) {
              svg {
                path {
                  fill: $color-white !important;
                }
              }
            }

            @include max-screen($screen-max-m) {
              top: 10px;
              position: absolute;
              right: 20px;
            }
          }
        }

        &.js-active {
          display: inline-block;
          @include min-screen($screen-min-m) {
            height: 100%;
            width: 100%;
          }

          .infobox-text {
            display: inline-block;
            opacity: 1;
            @include min-screen($screen-min-m) {
              height: 100%;
              width: 100%;
            }
          }
        }
      }
    }
  }
}
// product-teaser styles
.mod_product-teaser,
.mod_category-teaser {
  display: flex;
  flex-wrap: wrap;
}

.product-teaser,
.category-teaser {
  flex: 1 48%;
  margin-bottom: 50px;
  position: relative;
  text-align: center;
  max-width: 48%;

  a {
    color: transparent;
  }

  img {
    display: block;
    height: auto;
    width: 100%;
  }

  &:nth-child(even) {
    margin-left: 2%;
  }

  @include min-screen($screen-min-m) {
    flex: 1 32%;
    max-width: 32%;

    img {
      transform: translateY(0);
      transition: transform 0.2s ease-in-out;

      &:hover {
        transform: translateY(-4px);
      }

      &:active {
        transform: translateY(0);
      }
    }

    .flag-new {
      svg {
        transition: all 600ms ease-out;
        transform: scale(1);
      }
    }

    &:hover {
      svg {
        transform: scale(1.5);
      }
    }

    &:nth-child(even) {
      margin-left: 0;
    }

    &:nth-child(3n-1) {
      margin-left: 2%;
      margin-right: 2%;
    }
  }

  .product-teaser--info,
  .category-teaser--info {
    margin-top: auto;
    // padding-top: 10px;
    text-align: center;

    h5 {
      color: $color-green;
      display: block;
      font-size: inherit;
      line-height: 1.7em;
      margin: 0;
    }

    h6 {
      color: $color-green;
      display: block;
      font-size: 12px;
      margin: 0;
    }
  }

  .flag-new {
    position: absolute;
    top: 15px;
    right: 15px;
  }
}
// subnavigation variables
$tile-teaser--borderradius: 5px;

// subnavigation styles
.mod_subnavigation {
  text-align: center;

  ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    list-style: none;
    padding: 0;

    li {
      @include border-radius(5px);
      // color: $color-green;
      display: inline-block;
      margin: 5px 10px;
      padding: 5px 20px;
      transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;

      a,
      span {
        color: $color-green;
        display: block;
        transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
      }

      &:hover,
      &.active {
        // color: $color-white;
        background-color: $color-green;

        a,
        span {
          color: $color-white;
        }
      }
    }
  }
}

// ol.hooper-indicators li::before {
//   content: "";
// }
// .hooper-indicator {
//   height: 12px;
//   border-radius: 50%;
// }

// // SLIDER UTZ
// .slider-item--video {
//   position: relative;
//   position: relative;
//   padding-bottom: 56.25%;
//   height: 0;
//   overflow: hidden;
//   width: 100%;
//   height: auto;

//   video {
//     position: absolute;
//     top: 0;
//     left: 0;
//     width: 100%;
//     height: 100%;
//   }
// }

.carousel-3d-slider {
  left: 50%;
  transform: translateX(-50%);
  position: absolute !important;
  top: 50px;
  width: 100%;
  max-width: $maxwidth-wrapper;
  @include min-screen($screen-min-m) {
    top: 100px;
  }
}
.carousel-3d-container {
  // margin-bottom: 50px;
  overflow: hidden !important;
  // margin-top: 100px !important;
  margin-top: 0 !important;
  padding-top: 50px !important;
  padding-bottom: 50px !important;
  position: relative;
  //background-image: url("/files/images/backgrounds/Header-Product-Detail.png");
  background-size: cover;
  background-position: center bottom;
  min-height: 466px !important;

  @include min-screen($screen-min-m) {
    // margin-bottom: 80px !important;
    // margin-top: 200px !important;
    overflow: visible !important;
    margin-bottom: 80px !important;
    padding-bottom: 100px !important;
    padding-top: 100px !important;
    min-height: 566px !important;
  }
  & + .content-wrapper {
    padding-top: 300px;
  }
}
.carousel-3d-slider {
}
.carousel-3d-slide {
  overflow: visible;

  &.current {
  }
}
</style>